<button
  class="border-line-default focus:outline-line-brand flex h-9 w-full overflow-hidden rounded-lg border focus:outline disabled:bg-bg-surface-low"
  [class]="styleClass"
  [disabled]="disabled"
  (click)="showCalendar()">
  <div
    class="flex aspect-square h-full shrink-0 items-center justify-center"
    [class]="prefixStyleClass">
    <ic-calendar-outline class="text-icon-subtle block h-5 w-5" />
  </div>
  <input
    type="string"
    class="text-text-subtle placeholder:text-text-subtler h-full w-full cursor-pointer bg-transparent px-2 text-sm placeholder:text-sm placeholder:leading-none focus:border-0 focus:outline-0"
    [class]="inputStyleClass"
    [placeholder]="placeholder"
    [value]="valueDisplayed"
    readonly />
  <ng-content select="[template=suffix]" />
</button>

<p-dialog
  appendTo="body"
  styleClass="!bg-bg-surface-default !border-line-default !rounded-xl"
  [modal]="true"
  [dismissableMask]="true"
  [(visible)]="calendarVisible"
  (onHide)="onCalendarHidden()">
  <ng-template pTemplate="headless">
    <app-datepicker-default
      [maxDate]="_maxDate"
      [minDate]="_minDate"
      [selectMode]="selectionMode"
      [(startDate)]="valueDatepicker[0]"
      [(endDate)]="valueDatepicker[1]"
      (close)="calendarVisible = false"
      (endDateChange)="handleSelected()" />
    <div class="flex justify-end p-2 gap-2">
      <app-button
        theme="tint-brand"
        styleClass="!h-8 text-sm font-medium"
        (click)="resetSelected()">
        Reset
      </app-button>
      <app-button
        styleClass="!h-8 text-sm font-medium"
        (click)="applySelected()">
        Terapkan
      </app-button>
    </div>
  </ng-template>
</p-dialog>
